import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	askRovoCommandName: {
		id: 'compal.ask-rovo.command.name',
		defaultMessage: 'Ask Rovo',
		description: 'Name of the Ask Rovo command in the command palette',
	},
	askRovoCommandDescription: {
		id: 'compal.ask-rovo.command.description',
		defaultMessage: 'Get help from Rovo AI assistant',
		description: 'Description of the Ask Rovo command',
	},
});
